'use strict'

module.exports = identity

try {
  normalize('')
  module.exports = normalize
} catch (_) {}

// Normalize `uri`.
function normalize(uri) {
  return encodeURI(decodeURI(uri))
}

/* istanbul ignore next - Fallback, return input. */
function identity(uri) {
  return uri
}



//////////////////
// WEBPACK FOOTER
// ./~/normalize-uri/index.js
// module id = 1488
// module chunks = 2